import React, {
    ChangeEvent,
    KeyboardEvent,
    Suspense,
    useEffect,
    useState,
    useRef,
    useMemo,
} from "react";
import { useDispatch } from "react-redux";
import {
    BlockWrapper,
    ButtonsWrapper,
    GroupNameInput,
    HeaderTitle,
    MDPSettingsBlockWrapper,
    SettingsBlockHeader,
    SettingsBlockTitle,
    SettingsBlockWrapper,
    TickerNameInput,
    Workspace,
    Wrapper,
} from "pages/settings/settingsPageStyles";
import SavedSettingsBlock from "components/SettingsModules/SavedSettingsBlock/SavedSettingsBlock";
import CPSettings from "components/SettingsModules/CPSettingsBlock/CPSettings";
import MDPSettingsBlock from "components/SettingsModules/MDPSettingsBlock/MDPSettingsBlock";
import SPSettingsBlock from "components/SettingsModules/SPSettingsBlock/SPSettingsBlock";
import { RedButton } from "components/Buttons/buttonsStyles";
import AreYouSureModal from "components/AreYouSureModal/AreYouSureModal";
import {
    getMDPSourceTypes,
    setIsReset,
    getMDPParams,
    getSPParams,
    updateTickerSettings,
    dropDraft,
    setLoading,
    getMDP,
    getTickerSettings,
    hasChangesSelector,
} from "store/reducers/SettingsSlice";
import { useAppSelector } from "hooks/redux";
import { getDefaultTickers, getTickersByGroup, renameGroup, renameTicker } from "store/reducers/GroupsSlice";
import { setLogsTickerName } from "store/reducers/LogsSlice";
import { useLocation } from "react-router-dom";
import TradeParamsHandler, {
    TradeParamsRequest,
} from "utils/trade-params-handler";
import Error from "utils/Notifications/Error";

const useQuery = () => {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
};

const SettingsPage = () => {
    const {
        MDPSelectedItem,
        activeGroup,
        activeTicker,
        isReset,
        isChanged,
        isNewTickerAdding,
        saved_settings,
        savedSettings,
        saved_CP_settings,
        error,
    } = useAppSelector((state) => state.settings);
    const hasSettingsChanges = useAppSelector(hasChangesSelector);

    const { activeGroupTickers } = useAppSelector(state => state.groups)
    const get_ticker_settings_error = error;
    const q = useQuery();
    const [isButtonsActive, setButtonsActive] = useState(false)

    useEffect(() =>{
        dispatch(getDefaultTickers())
    },[activeGroupTickers])

    useEffect(() => {
        const ticker_name = q.get("ticker");

        if (typeof ticker_name === "string" && ticker_name.length) {
            const timeout = setTimeout(() => {
                scrollToTicker(ticker_name);
                clearTimeout(timeout);
            }, 300);
        }
    }, []);

    useEffect(() => {
        const g = activeGroup?.name;
        const t = activeTicker?.name;
        const ticker_placeholder = "название";

        const ticker_name =
            typeof t === "string"
                ? t.toLowerCase().includes(ticker_placeholder)
                    ? undefined
                    : t
                : undefined;

        const group_name = typeof g === "string" && g.length ? g : "default";

        if (!ticker_name || !group_name || activeTicker?.isNew) {
            return;
        }

        dispatch(
            getMDPParams({
                page: 1,
                search: ticker_name,
                group_name,
            })
        );
    }, [activeGroup?.name, activeTicker]);

    function scrollToTicker(ticker: string) {
        const el = document.getElementById(`ticker-item-${ticker}`);
        const container = document.getElementById(`ticker-items-wrapper`);
        if (el && container) {
            const child = container.children[0];
            if (child) {
                const offset = el.offsetTop;
                child.scrollTop = offset;
            }
        }
    }
    const tickersGroup = useAppSelector(
        (state) => state.groups.activeGroupTickers
    );
    const [isMDPExpanded, setIsMDPExpanded] = useState(false);
    const [isAreYouSureModalOpen, setIsAreYouSureModalOpen] = useState(false);

    const [areYouSureType, setAreYouSureType] = useState("");
    const [areYouSureMessage, setAreYouSureMessage] = useState<
        undefined | string
    >(undefined);
    const dispatch = useDispatch();

    const [newGroupName, setNewGroupName] = useState("");
    const [newTickerName, setNewTickerName] = useState("");
    const [CPColumnMask, setCPColumnMask]  = useState<string[][]>(JSON.parse(localStorage.getItem('CP_Mask')) || [[], [], []]);


    useEffect(() => {
        localStorage.setItem('CP_Mask', JSON.stringify(CPColumnMask))
    }, [CPColumnMask])

    useEffect(() => {
        dispatch(setLogsTickerName(""));
    }, [tickersGroup]);


    useEffect(() => {
        dispatch(getMDPSourceTypes());
        dispatch(getSPParams());
    }, []);

    useEffect(() => {
        setNewGroupName(activeGroup.name);
    }, [activeGroup.name]);

    useEffect(() => {
        setNewTickerName(activeTicker.name);
    }, [activeTicker.name]);

    useEffect(() => {
        if (activeTicker.name === "Название тикера") {
            setButtonsActive(false)
        } else {
            setButtonsActive(true)
        }
        // dispatch(getTickerSettings())
    }, [activeTicker]);

    useEffect(() => {
        _getMDPParams();
    }, [isNewTickerAdding]);


    const stateHasChanges = () => {
        const check = TradeParamsHandler.stateHasChanges({
            saved_settings,
            affiliation: {
                ticker_name: activeTicker.name,
                group_name: activeGroup?.name,
                exchange_name: MDPSelectedItem?.SPname,
            },
        });
        return isChanged || check;
    };

    const handleChangeGroupName = (e: ChangeEvent<HTMLInputElement>) => {
        // if (activeGroup.name === 'default') return
        if (stateHasChanges()) {
            Error("Редактирование недоступно при несохраненных настройках");
            return;
        }
        setNewGroupName(e.target.value);
    };

    const handleRenameGroup = (e: KeyboardEvent<HTMLInputElement>) => {
        if (activeGroup.name === "default") return;
        if (e.key !== "Enter") return;
        const timeout = setTimeout(() => {
            setIsAreYouSureModalOpen(true);
            setAreYouSureType("renameGroup");
            setAreYouSureMessage("Название группы будет изменено");
            clearTimeout(timeout);
        }, 50);
    };

    const handleChangeTickerName = (e: ChangeEvent<HTMLInputElement>) => {
        console.log("get_ticker_settings_error", get_ticker_settings_error);
        if (activeTicker.name === "default") return;
        if (
            typeof get_ticker_settings_error === "string" &&
            get_ticker_settings_error.length
        ) {
            Error("Редактирование заблокированного тикера недоступно");
            return;
        }
        if (stateHasChanges()) {
            Error("Редактирование недоступно при несохраненных настройках");
            return;
        }
        setNewTickerName(e.target.value);
    };

    const handleTabTitleBlur = () => {
        if (
            (newTickerName !== activeTicker?.name ||
                newGroupName !== activeGroup?.name) &&
            areYouSureType !== "renameTicker"
        ) {
            setIsAreYouSureModalOpen(true);
            setAreYouSureMessage("Изменения не сохранятся");
            setAreYouSureType("cancelRename");
            //activePage && setIsAreYouSureModalOpen(true)
        }
    };

    const handleRenameTicker = (e: KeyboardEvent<HTMLInputElement>) => {
        // if (activeGroup.name === 'default') return
        if (e.key !== "Enter") return;
        setIsAreYouSureModalOpen(true);
        setAreYouSureType("renameTicker");
        setAreYouSureMessage("Название тикера будет изменено");
    };

    const handleMDPExpandClick = () => {
        setIsMDPExpanded((prev) => !prev);
    };

    const handleCloseAreYouSureModal = () => {
        setIsAreYouSureModalOpen(false);
        setAreYouSureType("");
    };

    const handleResetSettingsButtonClick = () => {
        setIsAreYouSureModalOpen(true);
        setAreYouSureMessage(
            "Вы действительно хотите отменить введенные изменения?"
        );
        setAreYouSureType("resetSettings");
    };

    const handleApplySettingsButtonClick = () => {
        setIsAreYouSureModalOpen(true);
        if (activeGroup.name === "default") {
            setAreYouSureMessage("Данный тикер будет применен к роботу");
        } else
            setAreYouSureMessage(
                'Данный тикер будет включен в группу "Текущая"'
            );

        setAreYouSureType("applySettings");
    };

    const handleSaveSettingsButtonClick = () => {
        setIsAreYouSureModalOpen(true);
        setAreYouSureMessage(undefined);
        setAreYouSureType("saveSettings");
    };

    const updateSettings = (notify: boolean) => {
        return () => {
            const _saved_settings: any = {
                CP: savedSettings.CP,
                SP: savedSettings.SP,
            };
            const MDP = [];
            for (const key of Object.keys(savedSettings.MDP)) {
                let part = savedSettings.MDP[key];

                if (key === "values"){
                    part = part.map((tupleOfValues) => {
                        const newTuple = tupleOfValues.slice()
                        newTuple[2] = newTuple[2].replace("::copy", "")
                        return newTuple
                    })
                }
                MDP.push([...part]);
            }
            _saved_settings.MDP = MDP;

            const valid = TradeParamsHandler.validate(saved_settings);

            if (valid.length) {
                for (const error of valid) {
                    const { exchange_name, field, invalid_value } =
                        error;
                    const message = `
                    Ошибка валидации: ${exchange_name}
                    Параметр: ${field}
                    Значение: ${invalid_value}
                    `;
                    Error(message);
                    setIsAreYouSureModalOpen(false);
                    setAreYouSureType("");
                }
                setIsAreYouSureModalOpen(false);
                setAreYouSureType("");
                return;
            }
            let out;
            try {
                out = TradeParamsHandler.buildRequestBody(
                    "ticker_apply",
                    {
                        settings: saved_settings,
                        saved_settings: _saved_settings,
                        group_name: activeGroup.name,
                        ticker_name: activeTicker.name,
                        saved_CP_settings: saved_CP_settings,
                    }
                );
            } catch (error) {
                console.error(error);
                return Error(`Вот эту ошибку ищем: ${error.message}`);
            }
            //@ts-ignore
            let request_body: TradeParamsRequest = {};
            let has_error = false;
            for (const body of out) {
                const check = TradeParamsHandler.checkSP(body.SP);
                if (check.error) {
                    has_error = true;
                    Error(check.error);
                }
                const check_mdp = TradeParamsHandler.validateMDP(
                    body.MDP[1]
                );

                if (typeof check_mdp === "object" && check_mdp.error) {
                    Error(check_mdp.error);
                    setIsAreYouSureModalOpen(false);
                    setAreYouSureType("");
                    return;
                }

                if (!Object.keys(request_body).length) {
                    request_body = JSON.parse(JSON.stringify(body));
                    continue;
                }

            }
            if (!has_error) {
                // that should be done inside the TradeParamsHandler.buildRequestBody function but this code is fucking mess, so I made it like this
                dispatch(updateTickerSettings({
                    body: {
                        ...request_body,
                        SP: _saved_settings.SP,
                        MDP: [_saved_settings.MDP[0], ..._saved_settings.MDP[1]]
                    },
                    notify: notify
                }));
            }
            setIsAreYouSureModalOpen(false);
            setAreYouSureType("");
        };
    }

    const handleAreYouSureApplyFunc = (type: string) => {
        switch (type) {
            default:
                return;
            case "resetSettings":
                return () => {
                    dispatch(setLoading(true));
                    dispatch(dropDraft());
                    handleCloseAreYouSureModal();
                    dispatch(setIsReset(!isReset));
                    setAreYouSureType("");
                    const timeout = setTimeout(() => {
                        dispatch(setLoading(false));
                        clearTimeout(timeout);
                    }, 100);
                };
            case "applySettings":
                return updateSettings(true)
            case "saveSettings":
                return updateSettings(false);
            case "renameGroup":
                return () => {
                    setIsAreYouSureModalOpen(false);
                    setAreYouSureType("");
                    setNewGroupName(activeGroup.name);
                    dispatch(renameGroup(newGroupName));
                    unfocusInput();
                };
            case "renameTicker":
                return () => {
                    setIsAreYouSureModalOpen(false);
                    setNewTickerName(activeTicker.name);
                    dispatch(renameTicker(newTickerName));
                    setAreYouSureType("");
                    unfocusInput();
                };
            case "cancelRename":
                return () => {
                    setIsAreYouSureModalOpen(false);
                    setNewTickerName(activeTicker.name);
                    setNewGroupName(activeGroup.name);
                    setAreYouSureType("");
                };
        }
    };
    function unfocusInput() {
        const input = document.createElement("input");
        input.style.position = "absolute";
        input.style.bottom = "-150%";
        document.body.appendChild(input);
        input.focus();
        const timeout = setTimeout(() => {
            document.body.removeChild(input);
            return clearTimeout(timeout);
        }, 200);
    }

    function focusInput(type: "ticker" | "group") {
        return document.getElementById(`${input_id}-${type}`)?.focus();
    }

    const handleModalClose = () => {
        const changed =
            activeTicker?.name !== newTickerName ? "ticker" : "group";
        setIsAreYouSureModalOpen(false);
        if (areYouSureType === "cancelRename") {
            focusInput(changed);
        }
    };

    const _getMDPParams = () => {
        dispatch(getMDP());
    };

    const isTickerSelected = !(activeTicker.name === "Название тикера");
    const isGroupSelected = !(activeGroup.name === "Группа");
    const input_id = "ticker-settings-input";

    return (
        <Wrapper>
            <HeaderTitle>
                {isGroupSelected && (
                    <TickerNameInput
                        id={`${input_id}-ticker`}
                        value={
                            isTickerSelected ? newTickerName : "Выберите тикер"
                        }
                        // value={activeTicker.name}
                        disabled={
                            !isTickerSelected ||
                            isChanged ||
                            isNewTickerAdding ||
                            typeof get_ticker_settings_error === "string"
                        }
                        onChange={handleChangeTickerName}
                        onKeyDown={handleRenameTicker}
                        onBlur={handleTabTitleBlur}
                    />
                )}
                {isGroupSelected && " - "}
                {isGroupSelected && (
                    <GroupNameInput
                        id={`${input_id}-group`}
                        onChange={handleChangeGroupName}
                        onKeyDown={handleRenameGroup}
                        onBlur={handleTabTitleBlur}
                        value={
                            activeGroup.name === "default"
                                ? "Текущая"
                                : newGroupName
                        }
                        disabled={
                            activeGroup.name === "default" ||
                            isChanged ||
                            isNewTickerAdding ||
                            typeof get_ticker_settings_error === "string"
                        }
                    />
                )}
                {!isGroupSelected && !isGroupSelected && "Выберите группу"}
            </HeaderTitle>
            <Workspace>
                <SettingsBlockWrapper>
                    <SettingsBlockHeader>
                        <SettingsBlockTitle>
                            Сохраненные настройки
                        </SettingsBlockTitle>
                    </SettingsBlockHeader>
                    <BlockWrapper>
                        <SavedSettingsBlock />
                    </BlockWrapper>
                </SettingsBlockWrapper>

                {
                    <CPSettings
                        onArrowClick={handleMDPExpandClick}
                        changeCPColumnMask={setCPColumnMask}
                        CPColumnMask={CPColumnMask}
                        isExpanded={!isMDPExpanded}
                    />
                }

                {isMDPExpanded && (
                    <MDPSettingsBlockWrapper>
                        <SettingsBlockHeader>
                            <SettingsBlockTitle>MDP</SettingsBlockTitle>
                        </SettingsBlockHeader>
                        <BlockWrapper>
                            <MDPSettingsBlock />
                        </BlockWrapper>
                    </MDPSettingsBlockWrapper>
                )}

                {MDPSelectedItem.SPname !== "" && isMDPExpanded && (
                    <SPSettingsBlock />
                )}
            </Workspace>
            {
                <ButtonsWrapper>
                    {
                        <RedButton onClick={handleResetSettingsButtonClick} disabled={!hasSettingsChanges}>
                            Отменить
                        </RedButton>
                    }
                    <RedButton yellow onClick={handleApplySettingsButtonClick} disabled={!hasSettingsChanges}>
                        Применить
                    </RedButton>
                    {activeGroup.name !== "default" && (
                        <RedButton
                            green
                            onClick={handleSaveSettingsButtonClick}
                            disabled={!hasSettingsChanges}
                        >
                            Сохранить
                        </RedButton>
                    )}
                </ButtonsWrapper>
            }
            <Suspense fallback={<p>Loading...</p>}>
                {isAreYouSureModalOpen && (
                    <AreYouSureModal
                        title={"Вы уверены?"}
                        description={areYouSureMessage}
                        isOpen={isAreYouSureModalOpen}
                        onRequestClose={() => handleModalClose()}
                        onApplyClick={handleAreYouSureApplyFunc(areYouSureType)}
                    />
                )}
            </Suspense>
        </Wrapper>
    );
};

export default SettingsPage;
